// extracted by mini-css-extract-plugin
export default {"dataGrid":"datagrid_dataGrid__4nGam"};